module.exports = __webpack_public_path__ + "static/media/profile-info-reminder-exclamation.13f47003.svg";